import { Loader } from "@egovernments/digit-ui-react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import EnhancedTable from "./EnhancedTable";

const BPACommonSearchApp = () => {
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const { data, isLoading: loader } = Digit.Hooks.obps.useBPASearch(tenantId);

  if (loader) return <Loader />;

  return (
    <React.Fragment>
      <EnhancedTable data={data} isLoading={loader} tenantId={tenantId} />
    </React.Fragment>
  );
};

export default BPACommonSearchApp;
